import { League } from './League.js';

export { League };

/** Top-nav entry: renders the full League shell inside the main content area. */
export class Leagues {
    constructor(containerId, options = {}) {
        this.containerId = containerId;
        this.options = options;
        /** @type {League | null} */
        this.league = null;
    }

    init() {
        this.league = new League(this.containerId, this.options);
        this.league.init();
    }
}
